import { v4 as uuidv4 } from "uuid";
export class CalendarEventModel {
    constructor() {
        this.id = uuidv4();
        this.title = "";
        this.stateId = "";
        this.state = "";
        this.dueDate = "";
        this.dueDateAsString = "";
        this.url = "";
        this.description = "";
        this.createdBy = "";
        this.CreatedOn = null;
        this.recurrenceRuleValue = "";
        this.recurrenceStartDateAsString = "";
    }
}
export default class CalendarEvent extends CalendarEventModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
